export default __webpack_public_path__ + "static/front-cover-ocean-e2f47cef1d2d5598109fd636428abcd4.png";